// extracted by mini-css-extract-plugin
export default {"addToCartControl":"k2-z","giftCard":"l2-z","btnContainer":"m2-z","cartButton":"n2-z","disabled":"o2-z"};